<template>
  <div class="custom-order">
    <!-- 验证弹窗 -->
    <div class="validate-modal">
      <van-dialog
      v-model="showDialog"
      :show-cancel-button="false"
      :show-confirm-button="false"
      confirmButtonText="确定"
      title="需要输入手机号进行验证">
        <!-- <img src="../../assets/logo.png" alt=""> -->
        <van-field
        v-model="phone"
        type="tel"
        clearable
        class="field-phone"
        placeholder="请输入手机号"
        @keypress="clearMsg"
        @clear="clearMsg"/>
        <div v-if="showErr" class="error-message">{{errMsg}}</div>
        <van-button round class="confirm-button" @click="validatePhone" :loading="confirmLoading">确定</van-button>
      </van-dialog>
    </div>

    <!-- 定制详情 -->
    <div v-if="!showDialog">
      <div class="custom-order-detail" v-for="(orderItem, index) in orderInfo" :key="index">
        <van-cell-group class="order-info">
          <van-cell title="订单编号" value-class="sub-color" :value="orderItem.customOrder.orderSn" size="large" />
          <van-cell title="客户名称" value-class="sub-color" :value="orderItem.customOrder.nickname" size="large" />
          <van-cell title="客户手机" value-class="sub-color" :value="orderItem.customOrder.userPhone" size="large" />
        </van-cell-group>
        <div class="order-detail">
          <div class="order-detail-title">订单详情</div>
          <van-row class="order-item" v-for="(customeItem, customIndex) in changeItem(orderItem.items)" :key="customIndex">
            <van-col class="fz-17" span="5">{{customMap[customIndex]}}</van-col>
            <van-col class="sub-color" span="12">{{customeItem.name}}</van-col>
            <van-col class="price-color tr" span="7">&yen;{{customeItem.price}}</van-col>
          </van-row>
        </div>
        <van-cell-group class="order-info">
          <van-cell size="large" class="order-total">
            <template slot="title">
              <span class="order-fee">订单费用（合计）</span>
              <div class="pay-time">付款时间：{{orderItem.customOrder.payTime}}</div>
            </template>
            <span class="price-color">&yen;{{orderItem.customOrder.actualPrice}}</span>
          </van-cell>
        </van-cell-group>
      </div>
    </div>
  </div>
</template>

<script>
import { Field, Cell, CellGroup, Row, Col, Button, Toast } from 'vant'
import { getOrderByPhone } from 'api/custom'

export default {
  name: 'CustomOrder',
  components: {
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button
  },
  data () {
    return {
      showDialog: true,
      phone: '',
      showErr: false,
      errMsg: '输入错误',
      confirmLoading: false,
      orderInfo: [
        {
          customOrder: {},
          items: [{}, {}, {}, {}, {}]
        }
      ],
      customMap: [
        '车型', '发动机', '贴花', '大灯', '碟刹', '颜色'
      ]
    }
  },
  created () {
    this.getSessionData()
  },
  destroyed () {
    this.orderInfo = null
  },
  methods: {
    // 验证手机号码
    validatePhone () {
      if (!this.trim(this.phone)) {
        this.showErr = true
        this.errMsg = '请输入手机号'
        return
      }
      this.confirmLoading = true
      // 做个假的延迟， 可以删除
      // 不过这样button的loading就不明显了
      setTimeout(() => {
        this.getData()
      }, 300)
    },
    // 取数据
    getData () {
      getOrderByPhone({ phone: this.phone }).then(res => {
        const data = res.data
        if (data.code > 0) {
          this.errMsg = '输入出错'
          this.showErr = true
        } else {
          sessionStorage.setItem('phone', this.phone)
          this.orderInfo = data.data
          this.$dialog.close()
          this.showDialog = false
        }
      }).catch(err => {
        console.log(err)
        Toast.fail('请求出错')
      }).finally(() => {
        this.confirmLoading = false
      })
    },
    // 取session缓存中的数据
    // 如果有的话
    getSessionData () {
      if (sessionStorage.getItem('phone')) {
        this.phone = sessionStorage.getItem('phone')
        this.showDialog = false
        Toast.loading({
          mask: true,
          message: '加载中...'
        })
        getOrderByPhone({ phone: this.phone }).then(res => {
          const data = res.data
          if (Number(data.code) === 0) {
            this.orderInfo = data.data
          }
        }).catch((err) => {
          console.log(err)
          Toast.fail('请求出错')
        }).finally(() => {
          Toast.clear()
        })
      }
    },
    // 清除两端空格
    trim (str) {
      return str.replace(/\s+/g, '')
    },
    // 清空错误信息
    clearMsg () {
      this.showErr = false
      this.errMsg = ''
    },
    // 修改一下数据的顺序
    changeItem (items) {
      const tmp = items[2]
      items[2] = items[4]
      items[4] = tmp
      return items
    }
  }
}
</script>

<style scoped>
.error-message{
  color:red;
  margin: 0 auto;
  width: 90%;
  display: flex;
  padding: 6px 15px 0 15px;
  position: relative;
  box-sizing: border-box;
  overflow: hidden;
  font-size: 12px;
}
.custom-order-detail{
  margin-top: 70px;
}
.custom-order-detail:first-child{
  margin-top: 0;
}
.order-info{
  margin-top: 12px;
}
.order-fee{
  font-size: 17px;
}
.order-item{
  padding: 14px 16px;
  background-color: #fff;
}
.order-detail-title{
  font-size: 12px;
  color: #999;
  padding: 10px 0 10px 10px;
}
.price-color{
  color: #f20d02;
  font-size: 16px;
  word-break: break-all;
}
.fz-17{
  font-size: 17px;
}
.pay-time{
  font-size: 12px;
  color: #999;
}
.sub-color{
  color: #999;
  font-size: 16px;
}
</style>
<style>
.validate-modal .van-dialog{
  width: 272.5px;
}
.validate-modal .van-dialog__header{
  padding-top: 20px;
}
.validate-modal .van-dialog__content{
  padding: 20px 0 10px 0;
}
.validate-modal .confirm-button{
  display: block;
  margin: 18px auto 0 auto;
  width: 204px;
  height: 36px;
  line-height: 28px;
  border-radius: 18px;
  background-color: #F20D02;
  color: #fff;
  text-align: center;
  padding: 5px 20px;
}
.validate-modal .field-phone{
  width: 90%;
  margin: 0 auto;
}
.order-total .van-cell__title{
  flex: 2;
}
.sub-color{
  color: #999;
  font-size: 16px;
}
</style>
